import { loading, toast } from '@/shared/utils/UIHelper'
import AuthRepository from '@/shared/http/repositories/access/auth'
import AuthFilaRepository from '@/shared/http/repositories/access/authFila'

const SIGN_IN = 'signIn'
const SIGN_IN_FILA = 'signInFila'

export const actionTypes = {
  SIGN_IN,
  SIGN_IN_FILA
}

export const globalActions = {
  SIGN_IN: `signIn/${SIGN_IN}`,
  SIGN_IN_FILA: `signInFila/${SIGN_IN_FILA}`
}

export const actions = {
  [SIGN_IN]: async ({ state }) => {
    loading.push()

    return AuthRepository.SignIn(state.credentials)
      .then((res) => {
        loading.pop()
        return Promise.resolve({ success: true, res })
      })
      .catch((err) => {
        toast.error('Usuário ou senha inválidos')
        loading.pop()
        return Promise.reject(new Error('Not authorized', err))
      })
  },

  [SIGN_IN_FILA]: async ({ state }) => {
    loading.push()

    return AuthFilaRepository.SignInFila(state.credentials)
      .then((res) => {
        loading.pop()
        return Promise.resolve({ success: true, res })
      })
      .catch((err) => {
        toast.error('Usuário ou senha inválidos (Fila)')
        loading.pop()
        return Promise.reject(new Error('Not authorized', err))
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/signIn/actions.js